import { createContext, useContext } from 'react';

interface Ctx {
  open: () => void;
  close: () => void;
  isOpen: boolean;
}

export const CommandCtx = createContext<Ctx | null>(null);

export function useCommandPalette(): Ctx {
  const ctx = useContext(CommandCtx);
  if (!ctx) throw new Error('useCommandPalette requires provider');
  return ctx;
}
